import { Image } from 'antd';
import styled, { css } from 'styled-components';

export const AttentionHintWrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 12px;
  background: var(--v3-black-1);
  border-radius: 8px;
  gap: 8px;
`;

export const AttentionHintTopWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

export const AttentionHintTextWrapper = styled.div`
  margin: unset;
  color: var(--v3-text-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.28px;
`;

export const AttentionText = styled.p`
  color: var(--v3-text-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.28px;
`;

export const AttentionHintIcon = styled(Image)`
  &&& {
    width: 19px;
    height: 19px;
    transform: scaleX(-1);
  }
`;

export const AttentionHintText = styled.span<{ $sameLine?: boolean }>`
  color: var(--v3-primary-color);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.28px;
  margin: unset;
  padding-right: 5px;
  ${({ $sameLine }) =>
    $sameLine &&
    css`
      display: flex;
    `}
`;

export const AttentionHintInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
